<script>
    import { isEmpty } from 'src/utils/forms';

    export let label;

    $: formattedLabel = isEmpty(label) ? '—' : String(label);
</script>

<span>{formattedLabel}</span>
